import { create } from 'zustand';
import type { VehicleId } from '../types/gcs/vehicle';

export interface SelectedVehicle {
  vehicleId: VehicleId;
  gcsId: string;
}

interface SelectedVehicleStore {
  selectedVehicle: SelectedVehicle | null;
  toggleVehicle: (vehicleId: VehicleId, gcsId: string) => void;
  selectVehicle: (vehicleId: VehicleId, gcsId: string) => void;
  clearSelectedVehicle: () => void;
}

export const useSelectedVehicleStore = create<SelectedVehicleStore>((set, get) => ({
  selectedVehicle: null,
  toggleVehicle: (vehicleId: VehicleId, gcsId: string) => {
    const current = get().selectedVehicle;
    if (current?.vehicleId === vehicleId && current?.gcsId === gcsId) {
      set({ selectedVehicle: null });
      return;
    }
    set({ selectedVehicle: { vehicleId, gcsId } });
  },
  selectVehicle: (vehicleId: VehicleId, gcsId: string) => {
    set({ selectedVehicle: { vehicleId, gcsId } });
  },
  clearSelectedVehicle: () => set({ selectedVehicle: null })
}));
